//import {Link} from "../link/index.jsx";
import {Hashtag} from "./styles.js";

const HashtagLink = ({styles, color, children, ...props}) => {
  return (
    // <Link
    //   {...props}
    //   styles={{color: color === "white" ? "white" : "black", cursor: "default"}}
    // >
    <Hashtag styles={styles}>{children}</Hashtag>
    // </Link>
  );
};

export default HashtagLink;
